import { render, staticRenderFns } from "./TimeSpanField.vue?vue&type=template&id=43b3973c&scoped=true"
import script from "./TimeSpanField.ts?vue&type=script&lang=ts&external"
export * from "./TimeSpanField.ts?vue&type=script&lang=ts&external"
import style0 from "./TimeSpanField.vue?vue&type=style&index=0&id=43b3973c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3973c",
  null
  
)

export default component.exports